"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.AppContext = react_1.default.createContext({
    loading: true,
    initialState: {},
    error: null,
    refreshInitialState: function () { },
    setInitialState: function (initialState) { },
});
